import { render } from "./pay.vue?vue&type=template&id=583203f8&scoped=true&ts=true"
import script from "./pay.vue?vue&type=script&lang=ts"
export * from "./pay.vue?vue&type=script&lang=ts"

import "./pay.vue?vue&type=style&index=0&id=583203f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583203f8"]])

export default __exports__